import { Pipe, PipeTransform } from '@angular/core';
import { currencyMap } from '@app/configurations';

@Pipe({ name: 'currencySymbol' })
export class CurrencySymbolPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    return currencyMap[value]?.symbol || value;
  }
}
